import React, { useEffect, useState } from 'react';
import { IconButton } from "@hm-group/fabric-components/components/Buttons";
import { ArrowLeftIconMedium } from "@hm-group/fabric-icons/icons/ArrowLeftIcon";
import { ArrowRightIconMedium } from "@hm-group/fabric-icons/icons/ArrowRightIcon";
import { ChevronLeftIconSmall } from "@hm-group/fabric-icons/icons/ChevronLeftIcon";
import { ChevronRightIconSmall } from "@hm-group/fabric-icons/icons/ChevronRightIcon";
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import cn from 'classnames';
import "./ProductImageCarousel.css";
var styles = { "wrapper": "ba570e", "splide": "splide", "splide--rtl": "splide--rtl", "splide__container": "splide__container", "splide__sr": "splide__sr", "splide__track": "splide__track", "splide__track--draggable": "splide__track--draggable", "splide__list": "splide__list", "splide__slide": "splide__slide", "is-overflow": "is-overflow", "is-initialized": "is-initialized", "is-active": "is-active", "arrow": "e2c872", "arrowHidden": "c5012b", "arrows": "f5c14c", "arrow_prev": "fbc506", "arrow_next": "d4ffa2" };
const ProductImageCarousel = ({ children, className, variant = 'hm', labels = {
    carouselNextArrow: '',
    carouselPreviousArrow: '',
}, onSlideChange, }) => {
    const [isPreviousDisabled, setIsPreviousDisabled] = useState(true);
    const [isNextDisabled, setIsNextDisabled] = useState(false);
    const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
    const [swipedSlides, setSwipedSlides] = useState([0]);
    const [isNorthstar] = useState(variant === 'northstar-small' || variant === 'northstar-large');
    const ref = React.useRef();
    const handleArrowsUpdate = (_, prev, next) => {
        setIsPreviousDisabled(prev.disabled);
        setIsNextDisabled(next.disabled);
    };
    const handleMouseLeave = () => {
        if (isNorthstar) {
            ref.current.splide.go(0);
        }
    };
    const handleSlideMove = (splide) => {
        setSwipedSlides((e) => [...e, splide.index]);
        setCurrentSlideIndex(splide.index);
    };
    useEffect(() => {
        // This carousel does not have pagination.
        // Each pagination has only one slide, so each slide index corresponds to each pagination index.
        if (onSlideChange)
            onSlideChange(currentSlideIndex, currentSlideIndex, [...new Set(swipedSlides)]);
    }, [currentSlideIndex]);
    const childrenParsed = React.Children.toArray(children).map((child) => (React.createElement(SplideSlide, { key: child.key, tag: "li" }, child)));
    return (React.createElement("div", { className: cn(className, styles.wrapper), onMouseLeave: handleMouseLeave },
        React.createElement(Splide, { options: {
                perPage: 1,
                perMove: 1,
                pagination: false,
                lazyLoad: 'nearby',
                type: isNorthstar ? 'loop' : 'slide',
                i18n: Object.assign(Object.assign({ prev: labels.carouselPreviousArrow, next: labels.carouselNextArrow }, (isNorthstar && { last: labels.carouselPreviousArrow })), (isNorthstar && { first: labels.carouselPreviousArrow })),
            }, hasTrack: false, onArrowsUpdated: handleArrowsUpdate, onMoved: handleSlideMove, ref: ref },
            React.createElement(SplideTrack, null, childrenParsed),
            React.createElement("div", { className: cn('splide__arrows', styles.arrows) }),
            React.createElement(IconButton, { className: cn('splide__arrow', 'splide__arrow--prev', styles.arrow, styles.arrow_prev, isPreviousDisabled && !isNorthstar && styles.arrowHidden), role: "button", isDisabled: isPreviousDisabled, iconElement: isNorthstar ? React.createElement(ChevronLeftIconSmall, null) : React.createElement(ArrowLeftIconMedium, null), variant: "ghost", borderRadius: "round", "aria-hidden": isPreviousDisabled && !isNorthstar }, labels.carouselPreviousArrow),
            React.createElement(IconButton, { className: cn('splide__arrow', 'splide__arrow--next', styles.arrow, styles.arrow_next, isNextDisabled && !isNorthstar && styles.arrowHidden), role: "button", isDisabled: isNextDisabled, iconElement: isNorthstar ? React.createElement(ChevronRightIconSmall, null) : React.createElement(ArrowRightIconMedium, null), variant: "ghost", borderRadius: "round", "aria-hidden": isNextDisabled && !isNorthstar }, labels.carouselNextArrow))));
};
export default ProductImageCarousel;
//# sourceMappingURL=ProductImageCarousel.js.map